// extracted by mini-css-extract-plugin
export default {"bmdLabelFloating":"Text_bmdLabelFloating__btvsm","errorInput":"Text_errorInput__ZzR0e","bmdIcon":"Text_bmdIcon__Qe2A0","hasIcon":"Text_hasIcon__PUH3V"};